import React from "react";

import { useAppSelector } from "../../store";
import { getTournoi } from "../../features/tournoi/tournoiSlice";
import { resolveTournoiHome } from "../../utils/resolveTournoiHome";
import { HomePosterInteractive } from "./HomePosterInteractive";

export type HomePromo2026Props = {
  /** Réduit la hauteur max (home inscriptions ouvertes). */
  compact?: boolean;
};

/** Affiche interactive du tournoi chargé (fallback `/2026.png`, sauf `hidePoster`). */
export const HomePromo2026: React.FC<HomePromo2026Props> = ({
  compact = false,
}) => {
  const tournoi = useAppSelector(getTournoi);
  const home = resolveTournoiHome(tournoi);
  if (!home.posterUrl) {
    return null;
  }
  return (
    <HomePosterInteractive
      compact={compact}
      posterUrl={home.posterUrl}
      posterAlt={home.posterAlt}
    />
  );
};
